import { useCallback, useEffect, useState } from 'react';

export function useContainerQuery(minWidth: number) {
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  const [matches, setMatches] = useState(false);
  const ref = useCallback((node: HTMLDivElement | null) => setElement(node), []);

  useEffect(() => {
    if (!element) {
      setMatches(false);
      return;
    }
    const update = () => setMatches(element.clientWidth >= minWidth);
    update();
    if (!window.ResizeObserver) return;

    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, minWidth]);

  return { ref, matches };
}
